import { CalendarDateService, DateObject } from '@uplift/services';

const lateFeeHoursDelta = 24;

// true if current datetime is greater than 24 hours before fromDatetime
export const checkShowLateFee = (fromDatetime: string) => {
  const date = CalendarDateService.date(fromDatetime);
  const diff = date.diff(CalendarDateService.date(), 'hours');

  return diff < lateFeeHoursDelta;
};

const disabledLateFeeSelectionDelta = 7;

// true if current datetime is more than 24 hours before or 7 days after fromDateTime
export const checkDisableLateFeeSelection = (fromDatetime: string | DateObject) => {
  const date = CalendarDateService.date(fromDatetime);
  const beforeDiff = date.diff(CalendarDateService.date(), 'hours');
  const afterDiff = CalendarDateService.date().diff(date, 'days');

  return beforeDiff >= lateFeeHoursDelta || afterDiff >= disabledLateFeeSelectionDelta;
};
